import React from "react";
import { StaticQuery, graphql } from "gatsby";
import { Link } from "gatsby";
import Menu from "./Menu";
import MenuMobile from "./MenuMobile";
import Hidden from "@material-ui/core/Hidden";
import Grid from "@material-ui/core/Grid";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import Avatar from "@material-ui/core/Avatar";
import { MaterialUi } from "mdi-material-ui";

import grey from "@material-ui/core/colors/grey";

import headerLogo from "./header-logo.png";


const Header = props => {
  return (
    <AppBar id="appBar" color="inherit">
      <Toolbar style={{ paddingLeft: "6px" }} variant="dense">
        <Grid
          container
          justify="space-between"
          alignItems="center"
          spacing={16}
        >
          <Grid item>
            <Hidden smDown>
              <Link to="/">
                <img
                  src={headerLogo}
                  style={{ height: "50px", margin: "4px", float: "left" }}
                  alt="logo"
                />
              </Link>
              <span
                style={{
                  color: "#000",
                  float: "left",
                  fontSize: "32px",
                  padding: "8px 10px 0px"
                }}
              >
                OB交響楽団
              </span>
            </Hidden>
            <Hidden mdUp>
            <Link to="/">
                <img
                  src={headerLogo}
                  style={{ height: "50px", marginTop: "4px", float: "left" }}
                  alt="logo"
                />
              </Link>
              <span
                style={{
                  color: "#000",
                  float: "left",
                  fontSize: "32px",
                  padding: "8px 10px 2px"
                }}
              >
                OB交響楽団
              </span>
            </Hidden>
          </Grid>
          <Grid item>
            <Hidden smDown>
              <Typography
                style={{ color: "#efefef", flex: 1 }}
                component="span"
                variant="caption"
              >
                <Menu />
              </Typography>
            </Hidden>
            <Hidden mdUp>
              <MenuMobile />
            </Hidden>
          </Grid>
        </Grid>
        <Grid item />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
